import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { MenuItem, Paper, TextField, Popover, SelectField, Toggle, FlatButton } from 'material-ui';
import { getProviders } from 'dash-front/inputs/common';
import { safeParse } from 'dash-front/helpers';
const ODD_TYPES = ['match', 'nextGoal', 'halftime'];

export const OddsPicker = connect(state => ({
    defaultProvider: get(state, ['user', 'props', 'oddsProvider']),
    allowedProviders: get(state, ['user', 'props', 'allowedProviders']),
}))(
    class extends React.PureComponent {
        constructor(props, ctx) {
            super(props, ctx);
            const { defaultProvider, allowedProviders } = props;
            const providers = getProviders(safeParse(allowedProviders));
            const provider = defaultProvider && providers.some(p => p.id === defaultProvider) ? defaultProvider : null;
            this.state = {
                provider,
                providers,
                popoverOpen: false,
                popoverElement: null,
                oddType: null,
                isOptional: false,
                defaultText: '',
            };
        }

        componentWillReceiveProps({ allowedProviders }) {
            if (this.props.allowedProviders !== allowedProviders) {
                const providers = getProviders(safeParse(allowedProviders));
                this.setState({ providers });
            }
        }

        openPopover = event => {
            this.setState({
                popoverOpen: true,
                popoverElement: event.target,
            });
        };

        closePopover = () => {
            this.setState({ popoverOpen: false });
        };

        onAdd = () => {
            const { onAdd } = this.props;
            const { oddType, isOptional, defaultText, provider } = this.state;
            const value = `odds.${oddType}|provider=${provider}` + (isOptional ? `|default=${defaultText}` : '');
            onAdd(value);
            this.closePopover();
        };

        render() {
            const { popoverElement, popoverOpen, provider, oddType, isOptional, defaultText } = this.state;
            const { style = {} } = this.props;
            const canSave = oddType && provider;
            return (
                <div>
                    <Paper
                        style={{
                            display: 'inline-block',
                            margin: '16px 32px 16px 0',
                            ...style,
                        }}
                    >
                        <MenuItem onTouchTap={this.openPopover}>Odds</MenuItem>
                    </Paper>
                    <Popover open={popoverOpen} anchorEl={popoverElement} onRequestClose={this.closePopover}>
                        <Paper>
                            <div style={{ padding: 16 }}>
                                <div>
                                    <SelectField
                                        floatingLabelText="Provider"
                                        value={provider}
                                        onChange={(event, index, value) => this.setState({ provider: value })}
                                    >
                                        {this.state.providers.map(provider => (
                                            <MenuItem
                                                value={provider.id}
                                                key={provider.id}
                                                primaryText={provider.name}
                                            />
                                        ))}
                                    </SelectField>
                                </div>
                                <div>
                                    <SelectField
                                        value={oddType}
                                        floatingLabelText="Odd type"
                                        onChange={(event, index, value) => this.setState({ oddType: value })}
                                    >
                                        {ODD_TYPES.map(type => (
                                            <MenuItem primaryText={type} key={type} value={type} />
                                        ))}
                                    </SelectField>
                                </div>
                                <div>
                                    <Toggle
                                        label="Optional"
                                        toggled={isOptional}
                                        onToggle={(e, value) => this.setState({ isOptional: value })}
                                    />
                                    <TextField
                                        disabled={!isOptional}
                                        value={defaultText}
                                        onChange={(e, value) => this.setState({ defaultText: value })}
                                        floatingLabelText="Default text"
                                    />
                                </div>
                                <div>
                                    <FlatButton primary disabled={!canSave} label="Add" onTouchTap={this.onAdd} />
                                </div>
                            </div>
                        </Paper>
                    </Popover>
                </div>
            );
        }
    },
);

OddsPicker.propTypes = {
    onAdd: PropTypes.func.isRequired,
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/messages/components/OddsPicker.js
 **/